module.exports = __webpack_public_path__ + "static/media/loader.da2b63dd.gif";